module.exports = __webpack_public_path__ + "img/serve4.93364775.png";